import { SlideDuration } from './../enums';
import { SlideDurationMinMax } from './../interfaces';

export const SlideDurationValues: Record<SlideDuration, SlideDurationMinMax> = {
  [SlideDuration.Short]: { minDuration: 15, maxDuration: 25 },
  [SlideDuration.Medium]: { minDuration: 20, maxDuration: 35 },
  [SlideDuration.Long]: { minDuration: 25, maxDuration: 30 },
  [SlideDuration.Unknown]: { minDuration: 20, maxDuration: 35 },
};
